import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../context/auth';
import axios from 'axios';
import { Toasts } from '../toasts';
// TABLES
import TablaFicha from './tablaFichaCatastral';
import TablaTipologia from './tablaValorTipologia';
import TablaTierra from './tablaValorTierra';
import TablaDepre from './tablaDreciacion';
import TablaAvaluos from './tablaAvaluos';
// MODALS
import ImpCedulaCatastral from './impCeduldaCatastral';
import ImpNoVivienda from './impNoPoseerVivienda';
import TablaUsuarioCatastro from './tablaUsuariosCatastro';
// COMPONENTS.
import Menu from '../comun/Menu/Menu.jsx';
import Item from '../comun/Menu/Item.jsx';
import plano from '../../imagenes/plano.jpg';
import Notificacion from '../notificacion.js';
import imgCatastro from '../../imagenes/lg_catastro.png'
import Footer from '../Footer.js';
import CajaIngresosCastatro from './cajaingresosCatastro.js';
import ImpModalCajaCatastro from './modalImpCajaCatastro.js';

function MenuPrincipaCatastro() {

    const accfichacat = JSON.parse(localStorage.getItem('accfichacat')) === null ? "0000" : JSON.parse(localStorage.getItem('accfichacat')).trim();
    const accavaluo = JSON.parse(localStorage.getItem('accavaluo')) === null ? "0000" : JSON.parse(localStorage.getItem('accavaluo')).trim();
    const accvalorterrecat = JSON.parse(localStorage.getItem('accvalorterrecat')) === null ? "0000" : JSON.parse(localStorage.getItem('accvalorterrecat')).trim();
    const accdepreciacioncat = JSON.parse(localStorage.getItem('accdepreciacioncat')) === null ? "0000" : JSON.parse(localStorage.getItem('accdepreciacioncat')).trim();
    const accvalortipocat = JSON.parse(localStorage.getItem('accvalortipocat')) === null ? "0000" : JSON.parse(localStorage.getItem('accvalortipocat')).trim();
    const accfacturar = JSON.parse(localStorage.getItem('accfacturar')) === null ? "0" : JSON.parse(localStorage.getItem('accfacturar')).trim();
    const accusuariocat = JSON.parse(localStorage.getItem('accusuariocat')) === null ? "0000" : JSON.parse(localStorage.getItem('accusuariocat')).trim();

    const accrepcedcat = JSON.parse(localStorage.getItem('accrepcedcat')) === null ? "0" : JSON.parse(localStorage.getItem('accrepcedcat')).trim();
    const accrepceremp = JSON.parse(localStorage.getItem('accrepceremp')) === null ? "0" : JSON.parse(localStorage.getItem('accrepceremp')).trim();
    const accrepconstancia = JSON.parse(localStorage.getItem('accrepconstancia')) === null ? "0" : JSON.parse(localStorage.getItem('accrepconstancia')).trim();
    const accrepgenseccat = JSON.parse(localStorage.getItem('accrepgenseccat')) === null ? "0" : JSON.parse(localStorage.getItem('accrepgenseccat')).trim();
    const accrepvalconstruc = JSON.parse(localStorage.getItem('accrepvalconstruc')) === null ? "0" : JSON.parse(localStorage.getItem('accrepvalconstruc')).trim();
    const accrepvalterreno = JSON.parse(localStorage.getItem('accrepvalterreno')) === null ? "0" : JSON.parse(localStorage.getItem('accrepvalterreno')).trim();
    const accrepdepreciacion = JSON.parse(localStorage.getItem('accrepdepreciacion')) === null ? "0" : JSON.parse(localStorage.getItem('accrepdepreciacion')).trim();
    const accreptransdiarias = JSON.parse(localStorage.getItem('accreptransdiarias')) === null ? "0" : JSON.parse(localStorage.getItem('accreptransdiarias')).trim();

    const { user } = useContext(AuthContext);
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [operacion, setOperacion] = useState(0)
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [idefiscal] = useState(localStorage.getItem('idefiscal'));
    const [aniofiscal] = useState(localStorage.getItem('efiscalanio'));
    const [mostrarImp, setMostrarImp] = useState(false);

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../src/modulos/datos');

    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }
    const actualizacionItem = {
        title: 'actualizacion',
        icon: 'fas fa-pen-alt me-2',
        drop: [
            {
                title: 'ficha catastral',
                itemClickValue: 1,
                permission: accfichacat === "0000" ? false : true,
                subDrop: null,
                icon: 'fa fa-map me-2'
            },
            {
                title: "avaluos",
                itemClickValue: 2,
                permission: accavaluo === "0000" ? false : true,
                subDrop: null,
                icon: 'fa fa-map me-2'
            },
            {
                title: 'Tabla de Valoración de la Construcción',
                itemClickValue: 3,
                permission: accvalortipocat === "0000" ? false : true,
                subDrop: null,
                icon: 'fa fa-map me-2'
            },
            {
                title: 'tabla de valoracion de la tierra',
                itemClickValue: 4,
                permission: accvalorterrecat === "0000" ? false : true,
                subDrop: null,
                icon: 'fa fa-map me-2'
            },
            {
                title: 'depreciaciones de edificaciones',
                itemClickValue: 5,
                permission: accdepreciacioncat === "0000" ? false : true,
                subDrop: null,
                icon: 'fa fa-map me-2'
            },

            {
                title: 'Generar Pagos/Número',
                itemClickValue: 9,
                permission: accfacturar === "0" ? false : true,
                icon: 'fas fa-money-bill me-2',
            },
        ],
    }
    const imprimirItem = {
        title: 'imprimir',
        icon: 'fa fa-print me-2',
        drop: [
            // {
            //     title: 'Resumen de Caja',
            //     itemClickValue: 20,
            //     icon: 'fas fa-print me-2',
            // },
            {
                title: 'Ejecucion presupuestaria inmuebles urbanos',
                itemClickValue: 11,
                props: 0
            },
            {
                title: 'Cedula Catastral',
                itemClickValue: 10,
                props: 0
            },
            {
                title: 'Certificado de Empadronamiento',
                itemClickValue: 12,
                props: 0
            },
            {
                title: 'Constancia de No Poseer Vivienda',
                itemClickValue: 7,
                permission: accrepconstancia === "0" ? false : true,
            },
            {
                title: 'Constancia de Linderos',
                itemClickValue: 13,
                permission: accrepceremp === "0" ? false : true,
                props: 0
            },
            {
                title: 'Listado General por Sector',
                itemClickValue: 14,
                permission: accrepgenseccat === "0" ? false : true,
                props: 0
            },
            {
                title: 'Tabla de Valoración de la Construcción',
                itemClickValue: 15,
                permission: accrepvalconstruc === "0" ? false : true,
                props: 0
            },
            {
                title: 'Tabla de Valoración de la Tierra',
                itemClickValue: 16,
                permission: accrepvalterreno === "0" ? false : true,
                props: 0
            },
            {
                title: 'Tabla de Depreciacion de las Edificaciones',
                itemClickValue: 17,
                permission: accrepdepreciacion === "0" ? false : true,
                props: 0
            },
            {
                title: 'Listado de Avaluo',
                itemClickValue: 18,
                permission: accreptransdiarias === "0" ? false : true,
                props: 0
            },
            {
                title: 'Listado General de Cédulas Catastrales',
                itemClickValue: 19,
                permission: accrepgenseccat === "0" ? false : true,
                props: 0
            },
            {
                title: 'listado general de impresion de certificados de empadronamiento',
                itemClickValue: 20,
                permission: accrepgenseccat === "0" ? false : true,
                props: 0
            },
            
            
        ]
    }
    const configuracionItem = {
        title: 'configuracion',
        icon: 'fa fa-cog me-2',
        drop: [
            {
                title: 'usuarios',
                icon: 'fa fa-user me-2',
                itemClickValue: 8,
                permission: accusuariocat === "0000" ? false : true,
            },
        ]
    }

    const PorDefecto = () => {
        const azulProfundo = "#003a70";
        const azulVibrante = "#007bff";
    
        return (
          <section
            className="col-12 m-0 p-0"
            style={{ height: "90dvh", overflow: "hidden" }}
          >
            <style>{`
                 @keyframes float {
                   0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
                   50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
                   100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
                 }
                 .tech-dot {
                   position: absolute;
                   background: white;
                   border-radius: 50%;
                   animation: float 6s infinite ease-in-out;
                 }
               `}</style>
    
            <div
              className="col-md-12 row mx-auto px-0"
              style={{ minHeight: "100%" }}
            >
              <div
                className="col-md-6 d-flex justify-content-center align-items-center"
                style={{
                  position: "relative",
                  left: "-50px",
                  borderBottomRightRadius: "30%",
                  height: "90dvh",
                  backgroundColor: azulProfundo,
                  overflow: "hidden",
                  boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
                }}
              >
                {/* 1. FONDO MESH GRADIENT (Profundidad) */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: `
                       radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                       radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                       ${azulProfundo}
                     `,
                  }}
                />
    
                {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                       linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                    backgroundSize: "50px 50px",
                  }}
                />
    
                {/* 3. PUNTOS ANIMADOS (Partículas) */}
                <div
                  className="tech-dot"
                  style={{
                    width: "6px",
                    height: "6px",
                    top: "20%",
                    left: "15%",
                    animationDelay: "0s",
                  }}
                />
                <div
                  className="tech-dot"
                  style={{
                    width: "4px",
                    height: "4px",
                    top: "60%",
                    left: "25%",
                    animationDelay: "1s",
                  }}
                />
                <div
                  className="tech-dot"
                  style={{
                    width: "8px",
                    height: "8px",
                    top: "40%",
                    left: "80%",
                    animationDelay: "2s",
                  }}
                />
                <div
                  className="tech-dot"
                  style={{
                    width: "3px",
                    height: "3px",
                    top: "80%",
                    left: "60%",
                    animationDelay: "1.5s",
                  }}
                />
    
                {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                    transform: "skewX(-20deg)",
                  }}
                />
    
                {/* LOGO CON GLOW */}
                <div
                  style={{ position: "relative", zIndex: 10, textAlign: "center" }}
                >
                  <img
                    style={{
                      filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                      maxWidth: "80%",
                      transition: "transform 0.3s ease",
                    }}
                    className="img-fluid"
                    src={imgCatastro}
                    alt="Logo SIAP"
                  />
                </div>
              </div>
    
              {/* LADO DERECHO (Alcaldía) */}
              <div className="col-md-6 d-flex justify-content-center align-items-center">
                <img
                  className="img-fluid px-5"
                  src={op.imagenes + "/imagen?img=" + op.logocatastro}
                  style={{ maxWidth: "85%" }}
                />
              </div>
            </div>
          </section>
        );
      };



    const [show, setShow] = useState(false)
    const [tabla, setTabla] = useState(0);

    const vista = {
        0: <PorDefecto />,
        1: <TablaFicha setTabla={setTabla} />,
        2: <TablaAvaluos setTabla={setTabla} />,
        3: <TablaTipologia setTabla={setTabla} />,
        4: <TablaTierra setTabla={setTabla} />,
        5: <TablaDepre setTabla={setTabla} />,
        6: <ImpCedulaCatastral operacion={operacion} show={show} setShow={() => { setShow(false), setTabla(0), setOperacion(0) }} />,
        7: <ImpNoVivienda show={show} setShow={setShow} setTabla={setTabla} />,
        8: <TablaUsuarioCatastro setTabla={setTabla} />,
        9: <CajaIngresosCastatro />
    }

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        if (obj != null) {
            setFechaSistema(obj.fechasistema);
            var nanio = []
            var aini = parseInt(obj.anioactu) - 7;
            var afin = parseInt(obj.anioactu);
            for (let i = 1; i <= afin - aini; i++) {
                nanio.push({ anio: aini + i });
            }
        } else {
        }
    }, []);

    useEffect(() => {
        if (tabla === 10) {
            if (accrepcedcat === "1") {
                setOperacion(1);
                setTabla(6);
            } else {
                setToast({
                mostrar: true,
                mensaje: "No posee permiso para este modulo.",
                titulo: "Alerta.",
                });
                setTabla(0);
            }
        } else if (tabla === 19) {
            setOperacion(1)
            setMostrarImp(true)
        } else if (tabla === 12) {
            if (accrepceremp === "1") {
                setOperacion(2)
                setTabla(6)
            } else {
                setToast({
                mostrar: true,
                mensaje: "No posee permiso para este modulo.",
                titulo: "Alerta.",
                });
                setTabla(0);
            }
        } else if (tabla === 20) {
            setOperacion(1)
            setMostrarImp(true)
        }
    }, [tabla]);

    const [alert, setAlert] = useState(false)

    return user && (
        <div className='w-100 col-12 m-0 p-0'>
            <Notificacion show={alert} setShow={() => setAlert(false)} />
            <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)} >
                {accfichacat !== "0000" || accavaluo !== "0000" || accvalortipocat !== "0000" || accvalorterrecat !== "0000" || accdepreciacioncat !== "0000" || accfacturar !== "0" ? 
                <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} /> : ""}
                <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
                {accusuariocat === "0000" ? "" : <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />}
                <a href="/inicio" className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"><i className="fas fa-power-off me-2" />Salir</a>
            </Menu>
            <section className='w-100 col-12 m-0 p-0 d-flex align-items-center justify-content-center'
            >
                {vista[tabla]}
            </section>

            <ImpModalCajaCatastro
                operacion={operacion}
                reporte={tabla === 20 ? 1 : tabla === 19 ? 2 : 0}
                show={mostrarImp}
                onHideCancelar={() => { setMostrarImp(false), setTabla(0) }}

            />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />
            <Footer />


        </div>
    )
} export default MenuPrincipaCatastro;